import { useCallback, useEffect } from "react"

const useUser = () => {
  const fetchUser = useCallback(async () => {}, [])

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  return {
    loading: false,
    user: undefined,
    reloadUser: fetchUser
  }
}

export default useUser
